import React from 'react';
import { debounce } from 'lodash-es';
import { useMedia } from 'use-media';
import { mediaQueries } from '@components-shared/src/stitches';
import { useSafeLayoutEffect } from '@hooks/useSafeLayoutEffect';
import { createContainer } from '../utils/unstated';

function MediaQueryContainer() {
  const [hasAppMounted, setHasAppMounted] = React.useState(false);
  const mobile = useMedia(mediaQueries.mobile);
  const mobileLandscape = useMedia(mediaQueries.mobileLandscape);
  const embedMobile = useMedia(mediaQueries.embedMobile);
  const tablet = useMedia(mediaQueries.tablet);
  const tabletLandscape = useMedia(mediaQueries.tabletLandscape);
  const laptop = useMedia(mediaQueries.laptop);
  const desktop = useMedia(mediaQueries.desktop);
  const desktopMd = useMedia(mediaQueries.desktopMd);
  const desktopLg = useMedia(mediaQueries.desktopLg);
  const uploadFlow = useMedia(mediaQueries.uploadFlow);
  const [windowSize, setWindowSize] = React.useState(getSize);

  function getSize() {
    const dimensions = {
      width: 0,
      height: 0,
    };

    if (typeof window === 'undefined') return dimensions;

    dimensions.width = window.innerWidth;
    dimensions.height = window.innerHeight;

    return dimensions;
  }

  useSafeLayoutEffect(() => {
    setHasAppMounted(true);

    const handleResizeDebounced = debounce(function handleResize() {
      setWindowSize(getSize());
    }, 250);

    window.addEventListener('resize', handleResizeDebounced);
    return () => window.removeEventListener('resize', handleResizeDebounced);
  }, []);

  return {
    mobile,
    mobileLandscape,
    embedMobile,
    tablet,
    tabletLandscape,
    laptop,
    desktop,
    desktopMd,
    desktopLg,
    hasAppMounted,
    windowSize,
    uploadFlow,
  };
}

export const MediaQuery = createContainer(MediaQueryContainer);

export const useMediaQuery = () => MediaQuery.useContainer();
